import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { InstanceProvider } from './Contexts/InstanceContext';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store } from './store/store';
import { PostHogProvider } from 'posthog-js/react';
import { persistor } from './store/store';
import URLListener from './helpers/URLListener/URLListener';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>

        <InstanceProvider>
      
            <URLListener />
            <App />
     
        </InstanceProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
